import { useQuery } from "@tanstack/react-query";
import { getPublicModuleVisibility, listMunicipalModules } from "./access";

export const publicModuleVisibilityKey = ["public-module-visibility"] as const;

export function usePublicModuleVisibility() {
  return useQuery({
    queryKey: publicModuleVisibilityKey,
    queryFn: getPublicModuleVisibility,
    placeholderData: {},
    retry: false,
    staleTime: 60_000,
  });
}

export function isPublicModuleEnabled(
  visibility: Record<string, boolean>,
  moduleCode: string,
) {
  return visibility[moduleCode] !== false;
}

export function useMunicipalModuleVisibility(municipalityId: string) {
  return useQuery({
    queryKey: ["municipal-module-visibility", municipalityId],
    queryFn: async () =>
      Object.fromEntries(
        (await listMunicipalModules(municipalityId)).map((module) => [
          module.code,
          module.enabled,
        ]),
      ),
    placeholderData: {},
    enabled: Boolean(municipalityId),
    retry: false,
    staleTime: 60_000,
  });
}

